import { KText } from '@/ui-library/components';
import { Flex, Center } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useField } from 'formik';
import { DatePopOver } from './DatePopOver';

export const PauseForCustomField = () => {
  const [_field, meta, helpers] = useField('pauseUntill'); // eslint-disable-line
  const [_cusField, customMeta, customHelpers] = useField('customDate'); // eslint-disable-line
  const { setValue } = helpers; // eslint-disable-line
  const { setValue: setCustom } = customHelpers;
  const currDate = dayjs();

  const items = [
    {
      id: 'week',
      label: '1 week',
      date: currDate.add(7, 'day').format('DD/MM/YYYY'),
    },
    {
      id: 'month',
      label: '1 month',
      date: currDate.add(1, 'month').format('DD/MM/YYYY'),
    },
    {
      id: '3month',
      label: '3 months',
      date: currDate.add(3, 'month').format('DD/MM/YYYY'),
    },
  ];

  const onQuickClick = (item) => {
    setValue(item?.id);
    setCustom('');
  };

  const onCustomDateClick = (date, onClose = () => {}) => {
    setValue('custom');
    setCustom(date);
    onClose();
  };

  return (
    <Flex flexDir="column" gap="6px">
      <KText size="sm-semi-bold" color="secondary-900">
        Pause for
      </KText>
      <Flex
        border="1px solid"
        borderColor="border-color"
        borderRadius="sm"
        w="100%"
        h="50px"
        overflow="hidden"
      >
        {items?.map((item) => (
          <Center
            key={item?.id}
            w="25%"
            flexDir="column"
            borderRight="1px solid"
            borderColor="border-color"
            bg={meta?.value === item?.id && 'ats-primary'}
            cursor="pointer"
            onClick={() => onQuickClick(item)}
          >
            <KText
              size="sm-medium"
              color={meta?.value === item?.id ? 'base-white' : 'secondary-900'}
            >
              {item?.label}
            </KText>
            <KText
              size="sm-medium"
              color={meta?.value === item?.id ? 'base-white' : 'secondary-700'}
            >
              {item?.date}
            </KText>
          </Center>
        ))}
        <DatePopOver
          meta={meta}
          date={customMeta?.value}
          setDate={onCustomDateClick}
        />
      </Flex>
    </Flex>
  );
};
